/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsColorARGB
 */
export interface ControlcenterMelcoModelsColorARGB {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsColorARGB
     */
    argb?: string | null;
}

export function ControlcenterMelcoModelsColorARGBFromJSON(json: any): ControlcenterMelcoModelsColorARGB {
    return ControlcenterMelcoModelsColorARGBFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsColorARGBFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsColorARGB {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'argb': !exists(json, 'argb') ? undefined : json['argb'],
    };
}

export function ControlcenterMelcoModelsColorARGBToJSON(value?: ControlcenterMelcoModelsColorARGB | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'argb': value.argb,
    };
}


